/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react'
import {FilterIcon } from '../../ui-components/uim-components'
import {TextField} from "@mineral/core"
import './filter.less'

// TODO see if this component can be integrated into uim-react-component
// this is  a copy/paste from operatorconsole-ui
class Filter extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
  }
  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value)
    }
  }
  onKeyUp(evt) {
    let value = ''
    //clear filter when user presses esc key
    if (evt.which === 27) {
      this.props.onChange(value)
    }
  }
  render() {
    const fontColorStyle = { color: '#fff' }
    return (
      <div className="metric__filter">
        <FilterIcon className="metric-filter__icon" />
        <TextField
          {...this.props}
          hintStyle={fontColorStyle}
          inputStyle={fontColorStyle}
          name="filter"
          placeholder="no filter"
          onChange={this.handleChange}
          onKeyUp={this.onKeyUp}
        />
      </div>
    )
  }
}

export default Filter
